import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
let _vm = new Vue()

export default {
    namespaced: true,
    state: {
        discountList: []
    },
    mutations: {
        // data: { key: state中需要改变值的key名，传数组支持深度赋值(eval处理), value: 赋值的数据 }
        setStoreData (state, data) {
            let key = data.key
            if (Array.isArray(key)) {
                let zhizhen = ''
                while (key.length > 0) {
                    zhizhen += "['" + key.shift() + "']"
                }
                eval("state" + zhizhen + '=' + JSON.stringify(data.value))
            } else {
                state[data.key] = data.value
            }
        }
    },
    actions: {
        async getDiscountList ({ commit }) {
            let response = await _vm.fetch('/boss/common/config/v2/getDiscountActivity', '', 'get')
            response && response.code === 0 && commit('setStoreData', {
                key: 'discountList', value: response.data || []
            })
        }
    }
}
